import { StatesMachine } from "./state-machine";
import { PipelineStatsPayload } from "./state";

export type PipelineAction =
  | { type: "SET"; payload: StatesMachine }
  | {
      type: "MUTATE";
      updater: (machine: StatesMachine) => StatesMachine | void;
    }
  | { type: "UPDATE_STATS"; payload: PipelineStatsPayload };

export const pipelineReducer = (
  state: StatesMachine | undefined,
  action: PipelineAction
): StatesMachine | undefined => {
  switch (action.type) {
    case "SET": {
      return action.payload.clone();
    }
    case "MUTATE": {
      if (!state) return state;

      const draft = state.clone();
      const updatedState = action.updater(draft);
      const nextState = updatedState ?? draft;

      nextState.syncTransitionsBySequence();
      return nextState;
    }
    case "UPDATE_STATS": {
      if (!state) return state;
      const { payload } = action;
      if (!payload || !payload.states || typeof payload.states !== "object")
        return state;
      if (
        payload.id !== undefined &&
        state.id !== undefined &&
        payload.id !== state.id
      )
        return state;
      const cloned = state.clone();
      cloned.updateStats(payload);
      return cloned;
    }
    default:
      return state;
  }
};
